export const getBasePath = () => {
    return import.meta.env.VITE_BASE_URL || '';
};
